import { createStyles, makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) =>
  createStyles({
    container: {
      padding: '0px!important',
    },
    gridMain: {
      width: '95%!important',
    },
    titleMain: {
      textAlign: 'center',
      margin: '0px 0 5px 0!important',
    },
    textQtFlavorMain: {
      textAlign: 'center',
      fontSize: 13,
      margin: '0px!important',
    },
    hr: {
      border: '0.5px solid #f1f1f1!important',
      margin: '10px auto!important',
      width: '95%',
    },
    hrObs: {
      border: '0.5px solid #f1f1f1!important',
      margin: '5px auto!important',
      width: '95%',
    },
    inputText: {
      margin: '5px 0!important',
      padding: '6px 35px!important',
      width: '100%',
      backgroundColor: '#fef0ef',
    },
    inputTextModal: {
      margin: '5px 0!important',
      padding: '6px 35px!important',
      width: '85%',
      backgroundColor: '#fef0ef',
    },
    textModalSuccessRequest: {
      margin: '0px 10px!important',
      fontWeight: 600,
      padding: '6px 35px!important',
      width: '85%',
      backgroundColor: '#fef0ef',
    },
    gridLocation: {
      display: 'flex',
      backgroundColor: '#fef0ef',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '0px 10px',
      borderRadius: 8,
    },
    gridIconLocation: {
      margin: '10px 0 5px 0!important',
    },
    titleLocation: {
      margin: '0px!important',
      color: '#292c32',
      fontSize: 13,
    },
    textDesLocation: {
      margin: '0px!important',
      color: '#696969',
      fontSize: 12,
    },

    gridProduct: {
      margin: '10px 0px!important',
    },
    gridBannerAndDes: {
      display: 'flex',
    },
    bannerProduct: {
      [theme.breakpoints.down('sm')]: {
        width: 60,
        height: 60,
      },
      width: 65,
      height: 65,
      borderRadius: 10,
      marginTop: 5,
      objectFit: 'contain',
    },
    titleProduct: {
      margin: '0px!important',
      color: '#292c32',
    },
    textDesProduct: {
      margin: '0px!important',
      color: '#8b8b8b',
      fontSize: 11,
      wordBreak: 'break-all',
    },

    svgCheck: {
      [theme.breakpoints.down('lg')]: {
        margin: '0px 28px!important',
      },
      [theme.breakpoints.down('md')]: {
        margin: '0px 28px!important',
      },
      [theme.breakpoints.down('sm')]: {
        margin: '0px 28px!important',
      },
      [theme.breakpoints.down('xs')]: {
        margin: '0px 19.5px!important',
      },
      margin: '0px 19.5px!important',
    },

    textValue: {
      margin: '0px 0px 0 5px!important',
      fontWeight: 550,
      color: '#b5423f',
      fontSize: 14,
    },
    textProduct: {
      color: '#929292',
      textAlign: 'left',
      fontSize: 12,
      wordWrap: 'break-word',
      margin: '0px!important',
    },

    gridVlQtProduct: {
      display: 'flex',
      justifyContent: 'space-between',
      marginTop: 5,
    },

    gridIncrementQtProduct: {
      display: 'flex',
    },

    textVlProduct: {
      color: '#a51614',
      margin: '0px!important',
      fontWeight: 550,
    },
    textQtProduct: {
      color: '#292c32',
      fontWeight: 550,
      margin: '0px 5px!important',
    },

    gridCuopom: {
      cursor: 'pointer',
      display: 'flex',
      backgroundColor: '#fef0ef',
      alignItems: 'center',
      padding: 10,
      borderRadius: 8,
      justifyContent: 'space-between',
    },
    gridIconCuopom: {
      margin: '0px 8px',
      display: 'flex',
    },
    textDesCuopom: {
      margin: '0px!important',
      color: '#696969',
      fontSize: 12,
    },

    gridValues: {
      padding: '0px 10px!important',
    },
    gridValue: {
      display: 'flex',
      justifyContent: 'space-between',
    },
    textDesValue: {
      margin: '0px!important',
      color: '#777777',
      fontSize: 13,
    },
    textVlValue: {
      fontWeight: 550,
      fontSize: 14,
      margin: '0px!important',
      color: '#292c32',
    },
    gridTotalValue: {
      display: 'flex',
      justifyContent: 'space-between',
      marginTop: 10,
    },
    titleTotalValue: {
      color: '#a51614',
      fontWeight: 550,
      margin: '0px!important',
    },
    textVlTotalValue: {
      color: '#a51614',
      margin: '0px!important',
      fontWeight: 550,
    },

    gridFormatPayment: {
      display: 'flex',
      backgroundColor: '#fef0ef',
      alignItems: 'center',
      padding: '0px 10px',
      justifyContent: 'space-between',
      borderRadius: 15,
    },
    gridIconFormatPayment: {
      margin: '0px 8px',
      display: 'flex',
      alignItems: 'center',
    },
    textDesFormatPayment: {
      margin: '0px!important',
      color: '#696969',
      fontSize: 12,
    },

    gridObservationMain: {
      marginTop: '15px!important',
      borderRadius: 10,
      border: '1px solid #bf5b59!important',
    },
    gridObservation: {
      display: 'flex',
      padding: '10px 10px 0 10px',
    },
    titleObservation: {
      marginLeft: '10px!important',
      color: '#b33d39',
      margin: '0px!important',
    },
    textArea: {
      width: '100%',
      height: '100px',
      border: 'none!important',
    },
    btnSubmit: {
      margin: '10px 0!important',
      backgroundColor: '#a51713!important',
      textTransform: 'uppercase',
      width: '100%',
      borderRadius: '10px!important',
    },

    btnModal: {
      margin: '10px 0!important',
      backgroundColor: '#a51713!important',
      width: '80%',
      borderRadius: '10px!important',
    },
    gridNameModal: {
      zIndex: 2,
      backgroundColor: '#fff',
      cursor: 'pointer',
      width: '100%',
      padding: '6px 20px',

      justifyContent: 'space-between!important',
    },
    nameModal: {
      textTransform: 'none',
      margin: 0,
      color: '#4d5055',
      fontSize: 18,
    },

    textBtnSubmit: {
      textTransform: 'uppercase',
      margin: '0px!important',
      marginRight: '10px!important',
    },

    titleModal: {
      textTransform: 'uppercase',
      margin: '10px 0 0px 0!important',
      width: '100%',
      justifyContent: 'center',
      textAlign: 'center',
    },
    textModal: {
      textAlign: 'center',
      marginBottom: '15px!important',
      margin: '0px 0!important',
      color: '#a8a8a8',
    },
    textModalConfirmRequest: {
      textAlign: 'center',
      margin: '0px 0!important',
      color: '#444',
    },
    iconModal: {
      width: 60,
      height: 60,
    },
    iconArrow: {
      marginLeft: 10,
    },
    textBtnKeepShopping: {
      color: '#292d32',
      margin: '0px 0!important',
    },

    gridModalTop: {
      borderTopRightRadius: 24,
      borderTopLeftRadius: 24,
      marginTop: '-2px!important',
      backgroundColor: '#a51713',
      textTransform: 'uppercase',
      color: '#fff!important',
      marginBottom: '10px!important',
    },

    titleModalTop: {
      textTransform: 'uppercase',
      margin: '10px!important',
    },

    gridTextAddressList: {
      justifyContent: 'center',
      alignItems: 'center',
      textAlign: 'left',
      marginTop: 10,
      borderBottom: '#f5f5f5 solid 1px!important',
    },
    textDesAddress: {
      fontSize: 14,
      margin: 0,
      color: '#363a3e',
    },
    textDescriptionAddress: {
      margin: 0,
      fontSize: 13,
      color: '#bebebe',
    },

    gridFormatPaymentSelect: {
      borderBottom: '1px solid #efefef',
    },

    gridButtonAndValueToC: {
      position: 'fixed',
      background: '#fff',
      width: '100%',
      bottom: '0px',
      maxWidth: '680px',
    },

    keyPix: {
      margin: '0px 10px 0px 0px!important',
      color: '#fff',
      background: '#0065ffd6',
      padding: 2,
      borderRadius: 5,
    },

    gridInfoOrderConfirm: {
      display: 'block',
      padding: '0px 20px',
      marginBottom: 20,
    },
    gridInfoOrderConfirmAddress: {
      marginTop: 10,
      display: 'flex',
      alignItems: 'center',
    },
    gridInfoOrderConfirmAddressText: {
      margin: '0px 0px 0px 15px',
    },
    gridInfoOrderConfirmPayment: {
      marginTop: 15,
      display: 'flex',
      alignItems: 'center',
    },
    gridInfoOrderConfirmPaymentText: {
      margin: '0px 0px 0px 15px',
    },
    gridInfoOrderConfirmTextP: {
      margin: '0px 0px 0px 15px',
      fontSize: 13,
      color: '#444',
    },
    gridInfoOrderConfirmIcon: {
      width: 19,
      height: 20,
    },
  }),
);

export default useStyles;
